import React from 'react';

/**
 * Dashed empty state (matches PageShell `.page-empty`).
 */
function PageEmpty({ title, text, action, compact, children, className = '' }) {
  return (
    <div
      className={`page-empty${compact ? ' page-empty--compact' : ''}${className ? ` ${className}` : ''}`}
    >
      {title && <h2 className="page-empty__title">{title}</h2>}
      {text && <p className="page-empty__text">{text}</p>}
      {children}
      {action}
    </div>
  );
}

export default PageEmpty;
